// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","viewSwitch":"ViewSwitch_viewSwitch__EqD90","viewSwitch__radioBtn":"ViewSwitch_viewSwitch__radioBtn__FXwOn"};